export type AudioSource = 'microphone' | 'telephone'

export interface TracksReducer {
  audioSource: AudioSource
  enabledAudioTracks: string[]
  enabledVideoTracks: string[]
  hasAudioError: boolean
  hasAudioTrack: boolean
  hasVideoError: boolean
  hasVideoTrack: boolean
  isAudioFetching: boolean
  isVideoFetching: boolean
  maxRetries: number
  numAudioFetchAttempts: number
  numVideoFetchAttempts: number
  selectedAudioDeviceID: string
  selectedVideoDeviceID: string
}

export const defaultState: TracksReducer = {
  audioSource: 'microphone',
  enabledAudioTracks: [],
  enabledVideoTracks: [],
  hasAudioError: false,
  hasAudioTrack: false,
  hasVideoError: false,
  hasVideoTrack: false,
  isAudioFetching: false,
  isVideoFetching: false,
  maxRetries: 6,
  numAudioFetchAttempts: 0,
  numVideoFetchAttempts: 0,
  selectedAudioDeviceID: '',
  selectedVideoDeviceID: ''
}

export default defaultState
